const Cubes = [
  // Cube1
  {
    top: {
      face: 'KubusEenBo',
    },
  },
  // Cube2
  {
    top: {
      face: 'KubusTweeBoonst',
    },
    right: {
      face: 'KubusTweeRegs',
    },
  },
  // Cube3
  {
    top: {
      face: 'KubusDrieBo',
    },
    right: {
      face: 'KubusDrieRegs',
    },
    left: {
      face: 'KubusDrieLinks',
    },
  },
  // Cube4
  {
    top: {
      face: 'KubusVierBoonst',
    },
    left: {
      face: 'KubusVierOor',
    },
  },
  // Cube5
  {
    right: {
      face: 'KubusVyfRegs',
    },
  },
  // Cube6
  {
    left: {
      face: 'KubusSesOor',
    },
  },
  // Cube7
  {
    top: {
      face: 'KubusSeweBoonste',
    },
    right: {
      face: 'KubusSeweRegs',
    },
  },
  // Cube8
  {
    top: {
      face: 'KubusBoonste',
    },
    right: {
      face: 'KubusAgtRegs',
    },
    left: {
      face: 'KubusAgtOo',
    },
  },
  // Cube9
  {
    right: {
      face: 'KubusNegeRegs',
    },
  },
  // Cube10
  {
    right: {
      face: 'KubusTienReg',
    },
    left: {
      face: 'KubusTienOor',
    },
  },
  // Cube11
  {
    top: {
      face: 'KubusElfBo',
    },
    right: {
      face: 'KubusElfRegs',
    },
    left: {
      face: 'KubusElfOor',
    },
  },
  // Cube12
  {
    top: {
      face: 'KubusTwaalfBo',
    },
    left: {
      face: 'KubusTwaalfOor',
    },
  },
  // Cube13
  {
    top: {
      face: 'KubusDertienBo',
    },
    right: {
      face: 'KubusDertienRegs',
    },
  },
  // Cube14
  {
    right: {
      face: 'KubusVeertienRegs',
    },
  },
  // Cube15
  {
    right: {
      face: 'KubusVyftienRegs',
    },
    left: {
      face: 'KubusVyftienOor',
    },
  },
  // Cube16
  {
    top: {
      face: 'KubusSestienBo',
    },
    right: {
      face: 'KubusSestienRegs',
    },
    left: {
      face: 'KubusSestienOor',
    },
  },
  // Cube17
  {
    right: {
      face: 'KubusSewentienRegs',
    },
    left: {
      face: 'KubusSewentienOor',
    },
  },
  // Cube18
  {
    top: {
      face: 'KubusAgtienBo',
    },
    right: {
      face: 'KubusAgtienRegs',
    },
    left: {
      face: 'KubusAgtienOor',
    },
  },
  // Cube19
  {
    top: {
      face: 'KubusNegentienBo',
    },
    right: {
      face: 'KubusNegentienRegs',
    },
    left: {
      face: 'KubusNegentienOor',
    },
  },
  // Cube20
  {
    top: {
      face: 'KubusTwintigBokant',
    },
    right: {
      face: 'KubusTwintigRegs',
    },
  },
  // Cube21
  {
    left: {
      face: 'KubusEenEnTwintigOor',
    },
  },
  // Cube22
  {
    right: {
      face: 'KubusTweeEnTwintigRegs',
    },
    left: {
      face: 'KubusTweeEnTwintigOor',
    },
  },
  // Cube23
  {
    right: {
      face: 'KubusDrieEnTwintigRegs',
    },
    left: {
      face: 'KubusDrieEnTwintigOor',
    },
  },
  // Cube24
  {
    top: {
      face: 'KubusVierEnTwintigBokant',
    },
    right: {
      face: 'KubusVierEnTwintigRegs',
    },
    left: {
      face: 'KubusVierEnTwintigOor',
    },
  },
  // Cube25
  {
    top: {
      face: 'KubusVyfEnTwintigBokant',
    },
    left: {
      face: 'KubusVyfEnTwintigOor',
    },
  },
  // Cube26
  {
    top: {
      face: 'KubusSesEnTwintigBokant',
    },
    right: {
      face: 'KubusSesEnTwintigRegs',
    },
    left: {
      face: 'KubusSesEnTwintigOor',
    },
  },
  // Cube27
  {
    top: {
      face: 'KubusSeweEnTwintigBo',
    },
    right: {
      face: 'KubusSeweEnTwintigRegs',
    },
    left: {
      face: 'KubusSeweEnTwintigOor',
    },
  },
];

export default Cubes;
